var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button is-link",attrs:{"type":"button"},on:{"click":_vm.print}},[_vm._v("ME CLICA:}")]),_vm._t("")],2)}
var staticRenderFns = []

export { render, staticRenderFns }